<template lang="pug">
.purchaseModalComponent
  .products
    .item(v-for="product in products")
      purchase-modal-product(
        :key="product.nomenklatura"
        :model="product"
        :is-in-basket="getIsInBasket(product.nomenklatura)"
        :is-selected="selectedProducts.includes(product.nomenklatura)"
        :is-purchased="userProducts.map(el => el.nomenklatura).includes(product.nomenklatura)"
        :subscription-expires="userProducts.find(el => el.nomenklatura === product.nomenklatura)?.expires"
        @select="onProductClick(product.nomenklatura)"
      )
  .button
    ui-button(
      :is-disabled="!selectedProducts.length && !itemsCount"
      @click="onButtonClick"
    ) Перейти к корзине
</template>

<script>
import { ref, inject, computed } from 'vue'
import { useRouter } from 'vue-router'
// import { PURCHASE_BASE_URL } from '@/config'
import purchaseModalMock from '@/mocks/purchase-modal'
import PurchaseModalProduct from './PurchaseModalProduct'
export default {
  components: {
    PurchaseModalProduct
  },
  emits: ['close'],
  setup (_, { emit }) {
    const store = inject('store')
    const router = useRouter()

    const userProducts = computed(() => {
      return store.user.profile?.subscriptions?.filter(el => el.bought) ?? []
    })

    const products = purchaseModalMock.products
    const selectedProducts = ref([])
    const onProductClick = nomenklatura => {
      if (selectedProducts.value.includes(nomenklatura)) {
        selectedProducts.value.splice(selectedProducts.value.findIndex(el => el === nomenklatura), 1)
      } else {
        selectedProducts.value.push(nomenklatura)
      }
    }

    const itemsCount = computed(() => store.basket.data?.itemsCount)

    const getIsInBasket = (nomenklatura) => {
      return !!store.basket.data?.items.find(o => o.nomenklatura === nomenklatura)
    }
    const onButtonClick = async () => {
      if (store.user.isAuthenticated) {
        const nomenclatures = []
        const data = [...selectedProducts.value]
        data.forEach(selectedProduct => {
          if (!store.basket.data?.items.find(o => o.nomenklatura === selectedProduct)) {
            nomenclatures.push(selectedProduct)
          }
        })
        if (nomenclatures.length) await store.basket.addProducts(nomenclatures)
        router.replace({ name: 'Basket' })
        emit('close')
      } else {
        store.user.login()
      }
    }
    return { products, selectedProducts, userProducts, onProductClick, onButtonClick, getIsInBasket, itemsCount }
  }
}
</script>

<style lang="sass" scoped>
.purchaseModalComponent
  padding-right: 10*$u

  > .products
    display: flex
    flex-wrap: wrap
    justify-content: center
    margin: -4*$u

    > .item
      margin: 4*$u

  > .button
    width: fit-content
    margin: 11*$u auto 0
</style>
